var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./task.constants";
export var getShowLimit = function (state) { var _a; return state[REDUCER_KEY] ? (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.showLimit : 0; };
export var isFetchingComments = function (state, taskId) {
    var _a, _b, _c;
    return state[REDUCER_KEY]
        ? (_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.comments) === null || _b === void 0 ? void 0 : _b[taskId]) === null || _c === void 0 ? void 0 : _c.isFetching
        : false;
};
export var fetchCommentsError = function (state, taskId) {
    var _a, _b, _c;
    return state[REDUCER_KEY]
        ? (_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.comments) === null || _b === void 0 ? void 0 : _b[taskId]) === null || _c === void 0 ? void 0 : _c.fetchError
        : undefined;
};
export var isCommentsExhausted = function (state, taskId) {
    var _a, _b, _c;
    return state[REDUCER_KEY]
        ? !!((_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.comments) === null || _b === void 0 ? void 0 : _b[taskId]) === null || _c === void 0 ? void 0 : _c.isExhausted)
        : false;
};
export var getTaskComments = function (state, taskId) {
    var _a, _b, _c;
    return state[REDUCER_KEY]
        ? (_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.comments) === null || _b === void 0 ? void 0 : _b[taskId]) === null || _c === void 0 ? void 0 : _c.items
        : undefined;
};
export var isCreatingComment = function (state, taskId) {
    var _a, _b, _c;
    return state[REDUCER_KEY]
        ? (_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.comments) === null || _b === void 0 ? void 0 : _b[taskId]) === null || _c === void 0 ? void 0 : _c.isCreating
        : false;
};
export var createCommentError = function (state, taskId) {
    var _a, _b, _c;
    return state[REDUCER_KEY]
        ? (_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.comments) === null || _b === void 0 ? void 0 : _b[taskId]) === null || _c === void 0 ? void 0 : _c.createError
        : undefined;
};
export var isDeletingComment = function (state, taskId) {
    var _a, _b, _c;
    return state[REDUCER_KEY]
        ? (_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.comments) === null || _b === void 0 ? void 0 : _b[taskId]) === null || _c === void 0 ? void 0 : _c.isDeleting
        : false;
};
export var deleteCommentError = function (state, taskId) {
    var _a, _b, _c;
    return state[REDUCER_KEY]
        ? (_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.comments) === null || _b === void 0 ? void 0 : _b[taskId]) === null || _c === void 0 ? void 0 : _c.deleteError
        : undefined;
};
export var getDetail = (_a = generateSelectors(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, getCreatedDetail = _a.getCreatedDetail, 
// getInfiniteLoad,
isCreating = _a.isCreating, createError = _a.createError, isUpdating = _a.isUpdating, updateError = _a.updateError, isRemoving = _a.isRemoving, removeError = _a.removeError, isArchiving = _a.isArchiving, archivingError = _a.archivingError;
